import React from "react";
import SectionReveal from "./SectionReveal";

const ValueProp = () => {
  return (
    <section
      id="value-prop"
      data-testid="value-prop-section"
      className="relative bg-[#050505] py-24 sm:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 grid md:grid-cols-12 gap-10 md:gap-16 items-start">
        <SectionReveal className="md:col-span-7">
          <span
            className="block text-xs font-bold uppercase tracking-[0.3em] text-zinc-500 mb-6"
            data-testid="value-prop-eyebrow"
          >
            01 — The Approach
          </span>
          <h2
            className="text-4xl sm:text-6xl lg:text-7xl font-black uppercase tracking-tight leading-[0.95] text-white"
            data-testid="value-prop-headline"
          >
            You don&apos;t
            <br />
            need a
            <br />
            <span className="text-zinc-500">camera crew</span>
          </h2>
        </SectionReveal>

        <SectionReveal className="md:col-span-5 md:pt-6" delay={0.15}>
          <p
            className="text-base sm:text-lg font-light text-zinc-400 tracking-wide leading-relaxed"
            data-testid="value-prop-body"
          >
            We craft <span className="text-white font-medium">VIDEO</span> and{" "}
            <span className="text-white font-medium">AUDIO</span> content without
            the constraints of traditional production. By combining advanced
            imaging tools, premium design assets, and bespoke creative design, we
            produce high-end corporate media at speed, with no sacrifice in
            quality — and it&apos;s all done remotely.
          </p>

          <div className="mt-10 grid grid-cols-3 gap-6 sm:gap-10 border-t border-white/10 pt-8">
            {[
              { k: "15+", v: "Years" },
              { k: "100%", v: "Remote" },
              { k: "∞", v: "Iterations" },
            ].map((m) => (
              <div key={m.v} data-testid={`stat-${m.v.toLowerCase()}`}>
                <div className="text-2xl sm:text-3xl font-black text-white">
                  {m.k}
                </div>
                <div className="mt-1 text-[10px] font-bold uppercase tracking-[0.25em] text-zinc-500">
                  {m.v}
                </div>
              </div>
            ))}
          </div>
        </SectionReveal>
      </div>
    </section>
  );
};

export default ValueProp;
